import { ApiProperty } from "@nestjs/swagger";

export class SupplierLoginDto{
    @ApiProperty()
    userName : string;
    @ApiProperty()
    password : string;
} 